import * as THREE from 'three';
export function createSimpleSatelliteDish(opts = {}) {
    const { radius = 600, depth = 160, // ↑ slightly deeper so it reads bigger
    thickness = Math.max(16, Math.round(radius * 0.05)), tiltDeg = 30, mastHeight = 620, // ↑ taller mast
    // lighter grays
    colors = { metal: 0xbcc5cf, dark: 0x8a9099, accent: 0xffa24a }, useAccent = false, } = opts;
    const root = new THREE.Group();
    root.name = 'SimpleSatelliteDish';
    // less metallic (so it doesn't go dark without an envMap), more diffuse
    const matMetal = new THREE.MeshStandardMaterial({
        color: colors.metal,
        metalness: 0.35,
        roughness: 0.6,
    });
    const matDark = new THREE.MeshStandardMaterial({
        color: colors.dark,
        metalness: 0.35,
        roughness: 0.65,
    });
    const matAccent = new THREE.MeshStandardMaterial({
        color: colors.accent,
        metalness: 0.3,
        roughness: 0.55,
    });
    const shadowize = (obj) => obj.traverse(o => {
        const m = o;
        if (m.isMesh) {
            m.castShadow = true;
            m.receiveShadow = true;
        }
    });
    // base (slightly taller to help the overall height read)
    const baseH = Math.max(90, Math.round(radius * 0.22));
    const base = new THREE.Mesh(new THREE.CylinderGeometry(radius * 0.45, radius * 0.55, baseH, 24), matDark);
    base.position.y = baseH / 2;
    // mast (taller by default)
    const mast = new THREE.Mesh(new THREE.CylinderGeometry(radius * 0.08, radius * 0.12, mastHeight, 16), matDark);
    mast.position.y = baseH + mastHeight / 2;
    // yoke
    const yoke = new THREE.Mesh(new THREE.BoxGeometry(radius * 0.24, radius * 0.16, radius * 0.5), matDark);
    yoke.position.y = mast.position.y + mastHeight * 0.2;
    // pivot
    const pivot = new THREE.Group();
    pivot.position.copy(yoke.position);
    pivot.rotation.x = THREE.MathUtils.degToRad(tiltDeg);
    // dish geometry (solid, no transparency)
    const radialSegs = 48;
    const heightSegs = 24;
    const k = depth / (radius * radius);
    const outerProfile = [];
    for (let i = 0; i <= heightSegs; i++) {
        const t = i / heightSegs;
        const r = t * radius;
        const y = k * r * r;
        outerProfile.push(new THREE.Vector2(r, y));
    }
    const rInner = Math.max(radius - thickness, 1);
    const dInner = Math.max(depth - thickness * 0.7, thickness * 0.5);
    const kInner = dInner / (rInner * rInner);
    const innerProfile = [];
    for (let i = 0; i <= heightSegs; i++) {
        const t = i / heightSegs;
        const r = t * rInner;
        const y = kInner * r * r;
        innerProfile.push(new THREE.Vector2(r, y));
    }
    const outerGeom = new THREE.LatheGeometry(outerProfile, radialSegs);
    const innerGeom = new THREE.LatheGeometry(innerProfile, radialSegs);
    const matInner = matMetal.clone();
    matInner.side = THREE.BackSide;
    const dishOuter = new THREE.Mesh(outerGeom, matMetal);
    const dishInner = new THREE.Mesh(innerGeom, matInner);
    const rimY = k * radius * radius;
    dishOuter.position.y = 0;
    dishInner.position.y = 0;
    // sealed rim band
    const rimBandH = Math.max(thickness * 0.85, 10);
    const rimBand = new THREE.Mesh(new THREE.CylinderGeometry(radius, rInner, rimBandH, 48, 1, false), matDark);
    rimBand.position.y = rimY - rimBandH / 2;
    // feed assembly
    const focus = (radius * radius) / (4 * depth);
    const poleH = Math.max(60, depth * 0.55);
    const feedPole = new THREE.Mesh(new THREE.CylinderGeometry(thickness * 0.12, thickness * 0.12, poleH, 10), matDark);
    feedPole.position.y = focus - poleH / 2;
    const feedCone = new THREE.Mesh(new THREE.ConeGeometry(thickness * 0.5, Math.max(44, depth * 0.48), 16), useAccent ? matAccent : matMetal);
    feedCone.position.y = focus + (Math.max(44, depth * 0.48) * 0.2);
    const dishGroup = new THREE.Group();
    dishGroup.add(dishOuter, dishInner, rimBand, feedPole, feedCone);
    pivot.add(dishGroup);
    root.add(base, mast, yoke, pivot);
    shadowize(root);
    return root;
}
